import { gql } from '@apollo/client';
import { AdminLayout } from 'components/admin/admin-layout';
import { Button } from 'components/buttons/button';
import { Spinner } from 'components/spinner';
import { useCmsGetAllCategoriesQuery } from 'lib/graphql-generated';
import Link from 'next/link';

const GET_CATEGORIES = gql`
  query CmsGetAllCategories {
    categories(order_by: { name: asc }) {
      name
      slug
      category_books_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

/**
 * Functionality:
 * 1. Blurb
 * 2. name
 * 3. add / remove books
 * 4.
 *
 */

export const Categories = () => {
  const { data, loading } = useCmsGetAllCategoriesQuery({
    fetchPolicy: 'cache-and-network',
  });

  return (
    <AdminLayout page='Categories'>
      <article>
        <header className='flex flex-col xl:flex-row flex-wrap w-full justify-center space-y-4 xl:space-y-0 xl:space-x-4'>
          <h1 className='header text-4xl ml-auto mr-auto xl:ml-0 xl:mr-auto'>
            Categories
          </h1>
        </header>
        {loading ? (
          <section className='flex justify-center pt-20'>
            <Spinner size={10} />
          </section>
        ) : (
          <ul className='mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-4'>
            {data?.categories?.map((category) => (
              <li
                key={`key_${category.name}`}
                className='col-span-1 shadow-sm rounded-md bg-white border border-gray-200 overflow-hidden hover:ring-1 ring-green-default cursor-pointer'>
                <Link href={`/admin/categories/${category.slug}`}>
                  <a className='flex'>
                    <article className='flex flex-row justify-start w-full flex-grow '>
                      <span className='bg-green-default p-4 text-white font-extrabold'>
                        {category.name.charAt(0)}
                      </span>
                      <h1 className='header my-auto ml-4'>{category.name}</h1>
                      <dl className='my-auto ml-auto p-4 bg-gray-100 flex w-16'>
                        <dt className='sr-only'>Books</dt>
                        <dd className='m-auto text-center w-full'>
                          {category.category_books_aggregate.aggregate.count}
                        </dd>
                      </dl>
                    </article>
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </article>
    </AdminLayout>
  );
};

export default Categories;
